import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Pagination } from "@material-ui/lab";
import { isEmpty } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getTickets } from "../../helpers/services/ContractServices";
import TicketRow from "./TicketRow";

const translationPath = "flokk_tickets";

const useTicketListStyles = makeStyles((theme) => ({
  root: {
    display: "grid",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
  },
}));

const TicketList = (props) => {
  const classes = useTicketListStyles();
  const { t } = useTranslation();
  const [page, setPage] = React.useState(0);

  const handleChange = (event, value) => {
    setPage(value - 1);
  };

  const { isLoading, data } = useQuery({
    queryKey: ["Tickets", props.trader_company_id, page],
    queryFn: () => getTickets(props.trader_company_id, page),
    enabled: Boolean(props.trader_company_id),
  });
  console.log("data", data);

  if (isLoading || isEmpty(data)) {
    return null;
  }

  return (
    <div className={classes.root}>
      <TableContainer component={Paper} variant="outlined" square>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{t(translationPath + ".entry_date")}</TableCell>
              <TableCell>
                {t(translationPath + ".trader_contact_person_id")}
              </TableCell>
              <TableCell>{t(translationPath + ".id_number")}</TableCell>
              <TableCell>{t(translationPath + ".servicerequest_no")}</TableCell>
              <TableCell>{t(translationPath + ".service_address")}</TableCell>
              <TableCell>{t(translationPath + ".ticket_no")}</TableCell>
              <TableCell>{t(translationPath + ".brand_id")}</TableCell>
              <TableCell>{t(translationPath + ".model")}</TableCell>
              <TableCell>{t(translationPath + ".no_of_items")}</TableCell>
              <TableCell>{t(translationPath + ".order_number")}</TableCell>
              <TableCell>{t(translationPath + ".prod_year")}</TableCell>
              <TableCell>{t(translationPath + ".defect_desc")}</TableCell>
              <TableCell>{t(translationPath + ".stage.name")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TicketRow key={row.id} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        color="primary"
        count={Math.ceil(props.count / 10)}
        page={page + 1}
        onChange={handleChange}
      />
    </div>
  );
};

export default TicketList;
